<script>
import { Icon } from "vant";
import cloneDeep from "lodash/cloneDeep";

export default {
  components: {
    [Icon.name]: Icon,
  },
  props: {
    value: {
      type: [Array, String],
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    valueField: {
      type: String,
      default: "Id",
    },
    textField: {
      type: String,
      default: "Name",
    },
    colnum: {
      type: Number,
      default: 3,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: [Array, String, Number],
      default: () => [],
    },
  },
  data() {
    return {
      checked: [],
    };
  },
  computed: {
    colnumStyle() {
      let str = "";
      for (let i = 0; i < this.colnum; i++) {
        str += " 1fr";
      }
      return str;
    },
  },
  created() {
    this.copyData();
    if (this.defaultValue) {
      this.checked = this.defaultValue;
      this.$emit("update", this.checked);
    }
  },
  methods: {
    copyData(val) {
      const value = val ? val : this.value;
      this.checked = cloneDeep(value);
    },
    updateData() {
      const json = [];
      if (this.startDate) {
        json.push(this.startDate);
      }
      if (this.endDate) {
        json.push(this.endDate);
      }
      this.$emit("update", json);
    },
    handleClick(key) {
      if (this.multiple) {
        const index = this.checked.indexOf(key);
        if (index > -1) {
          this.checked.splice(index, 1);
        } else {
          this.checked.push(key);
        }
      } else {
        this.checked = this.checked == key ? "" : key;
      }
      this.$emit("update", this.checked);
    },
    setValue(value) {
      this.copyData(value);
    },
  },
  render() {
    const buttons = this.data.map(item => {
      const option = {
        on: {
          click: () => {
            this.handleClick(item[this.valueField]);
          },
        },
      };

      if (
        (this.multiple && this.checked.includes(item[this.valueField])) ||
        this.checked === item[this.valueField]
      ) {
        option.class = "active";
      }
      if (item.disabled) {
        option.class = "disabled";
      }
      return (
        <div class="button-item" {...option}>
          {item[this.textField]}
        </div>
      );
    });
    const style = "grid-template-columns:" + this.colnumStyle + ";";
    return (
      <div class="button-list" style={style}>
        {buttons}
      </div>
    );
  },
};
</script>

<style lang="less" scoped>
.button-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-gap: 5px;
  .button-item {
    padding: 11px;
    background: #f1f1f1;
    // display: inline-block;
    text-align: center;
    border-radius: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.active {
      background: #1989fa;
      color: #fff;
    }
    &.disabled {
      background: #ddd;
      color: #888;
    }
  }
}
</style>
